var React = require('react');

function YoutubeVideo (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","id":"youtube"},[React.createElement("path",{"d":"m63.3850252.69507242h-46.7700504c-9.17620569 0-16.6149748 7.43876911-16.6149748 16.61497478v23.3800795c0 9.1762057 7.43876911 16.6149748 16.6149748 16.6149748h46.7700504c9.1762057 0 16.6149748-7.4387691 16.6149748-16.6149748v-23.3800795c0-9.17620567-7.4387691-16.61497478-16.6149748-16.61497478z","fill":"currentColor","key":0}),React.createElement("path",{"d":"m52.1484335 30.1376116-21.8758744 10.4334698c-.5829055.2780037-1.2562229-.1469845-1.2562229-.7927098v-21.5190857c0-.6549226.691018-1.0793902 1.2751382-.7833388l21.8758745 11.0856158c.6504107.3295438.6391309 1.2622967-.0189154 1.5760487z","fill":"#fff","key":1})]));
}

YoutubeVideo.defaultProps = {"height":"58","viewBox":"0 0 80 58","width":"80"};

module.exports = YoutubeVideo;

YoutubeVideo.default = YoutubeVideo;
